var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "58px",
    height: "61px",
    viewBox: "0 0 58 61",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "logo") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Designs",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "assets",
    transform: "translate(-432.000000, -742.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-24",
    transform: "translate(211.000000, 160.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "logo",
    transform: "translate(221.000000, 582.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-23",
    fill: "#000000"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-47",
    cx: 13,
    cy: 13,
    r: 13
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-51",
    cx: 45,
    cy: 13,
    r: 13
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-53",
    cx: 13,
    cy: 45,
    r: 13
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-52",
    cx: 45,
    cy: 45,
    r: 13
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-23-Copy",
    transform: "translate(0.000000, 3.000000)",
    fill: "#000000"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-47",
    cx: 13,
    cy: 13,
    r: 13
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-51",
    cx: 45,
    cy: 13,
    r: 13
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-53",
    cx: 13,
    cy: 45,
    r: 13
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-52",
    cx: 45,
    cy: 45,
    r: 13
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-11",
    fill: "#FD6687",
    cx: 13,
    cy: 13,
    r: 10
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-25",
    fill: "#FD6687",
    cx: 45,
    cy: 45,
    r: 10
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-23",
    fill: "#FFCE67",
    cx: 45,
    cy: 13,
    r: 10
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-24",
    fill: "#FFCE67",
    cx: 13,
    cy: 45,
    r: 10
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.18f406c1e091b7f33f727e65e6a8cf5b.svg";
export { ForwardRef as ReactComponent };